define('app/sdc/page/limit/sdc-page-limit-factory',["$mdMedia"], function ($mdMedia) {
	"use strict";
	var mediaSizes = ["sm", "md", "lg", "gt-lg", "gt-md", "gt-sm"];
	return sdcPageLimitFactory;
	function sdcPageLimitFactory(pageLimits) {
		if (angular.isObject(pageLimits)) {
			var pageLimit = angular.reduce(mediaSizes, function (limit, media) {
				return angular.isDefined(limit) ? limit : ($mdMedia(media) && angular.isDefined(pageLimits[media]) ? pageLimits[media] : limit)
			});
			return angular.isDefined(pageLimit) ? pageLimit : (pageLimits.default || 1);
		}
		else {
			return pageLimits;
		}
	}
});
